import React from 'react';

const ProgressBarStats = ({ title, data }) => {
  // Color palette for progress bars
  const colors = ['#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b'];
  
  // Find max count for percentage calculation
  let maxCount=0;
  if (data) {
    maxCount = Math.max(...data.map(item => item.count), 1);
  }

  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3">
        <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bold text-dark">  {title} </span>
            <span className="text-gray-400 mt-1 fw-semibold fs-6"> {title} by Orders</span>
        </h3>
      </div>
      <div className="card-body">
        {data && data.map((item, index) => (
          <div key={index} className="mb-4">
            <div className="d-flex align-items-center justify-content-between mb-1">
              <span className="font-weight-bold">{item.name}</span>
              <span className="text-gray-800">{item.count}</span>
            </div>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${(item.count / maxCount) * 100}%`,
                  backgroundColor: colors[index % colors.length]
                }}
                aria-valuenow={item.count}
                aria-valuemin="0"
                aria-valuemax={maxCount}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBarStats;
